import React, { useEffect, useState } from 'react';
import styles from './expenses.module.scss';
import { KoButton, KoForm, KoLoader, KoModal, KoNano, KoPagination, KoTable, KoText, KoTitle, KoToast, KoTooltips } from 'packages';
import { EXPENSES } from './constant';
import { InboxAPI } from '../inbox.service';
import ExpensesCurd from './curd';
import KoIcon from '@kwapio/icons';

export default function MyExpenses() {
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [form] = KoForm.useForm();
  const [isLoading, setLoading] = useState(false);
  const [currentRecord, setCurrentRecord] = useState();
  const [deleteExpense, setDeleteExpense] = useState(false);

  // FIXED: must be array (was {})
  const [expenseList, setExpenseList] = useState([]);

  const [pagination, setPagination] = useState({
    size: 10,
    offset: 0,
    page: 1
  });

  // FIXED: totalCount must have setter
  const [totalCount, setTotalCount] = useState(0);

  const onPagination = (page, other) => {
    const query = {
      size: other,
      page: page
    };
    const p = Object.assign(pagination, query);
    setPagination({ ...p });
  };

  const handleFinish = (values) => {
    if (!currentRecord?.expenseId) {
      values['expenseId'] = KoNano('Exp');
      values['lookupId'] = KoNano('EXP');
    }
    InboxAPI.createExpense(values, currentRecord?.expenseId).then(
      (data) => {
        setLoading(false);
        KoToast.success('Added successfully');
        getAllExpense();
      },
      (err) => {
        setLoading(false);
        KoToast.error('Something went wrong');
        console.log("Error:", err);
      }
    );
  };

  useEffect(() => {
    getAllExpense();
  }, []);

  // FIXED VERSION
  const getAllExpense = async() => {
    try {
      const res = await InboxAPI.getAllExpense();
      const items = Array.isArray(res?.expenses) ? res.expenses : [];
      setExpenseList(items);
      setTotalCount(res?.totalCount || items.length);
      console.log("Final Items:", items);
    } catch (error) {
      console.log("Error fetching Expense:", error);
    }
  };

  const columnsRight = [{
    title: '',
    dataIndex: 'x',
    key: 'x',
    fixed: 'right',
    width: 80,
    render: (text, row) => {
      return <div className={`tableBtn columnsRight`} onClick={() => { form.resetFields(); setCurrentRecord(row); }}>
        {row?.status === 0 &&  <KoTooltips title={'Edit'}>
          <KoButton className={'btn'} iconBtn={true} onClick={() => setIsModalOpen(true)} icon={<KoIcon width={14} height={14} name={'EditOutlined'} />}  />
        </KoTooltips>}
        {row?.status === 0 &&  <KoTooltips title={'Delete'}>
          <KoButton onClick={() => setDeleteExpense(true)} className={'btn'} iconBtn={true} icon={<KoIcon width={14} height={14} name={'DeleteOutlined'} />} />
        </KoTooltips>}
      </div>;
    }
  }];



  const onSort = (key, type) => {
    let q = pagination;
    q['sort'] = `${key}:${type}`;
    getAllExpense(q);
  };
  
  const onCellClick=(row)=>{
    setCurrentRecord(row);
    console.log("Row:", row);
    setIsModalOpen(true);
  };

  const handleFinishDelete=()=>{
    setLoading(true);
    InboxAPI.deleteExpense(currentRecord?.expenseId).then(
      (data) => {
        setLoading(false);
        setDeleteExpense(false);
        getAllExpense();
        KoToast.success(`Expense deleted successfully!`);
      },
      (err) => {
        setLoading(false);
        KoToast.error(`error`);
      }
    );
  };

  return (
    <div className={styles.wrapper}>
      {isLoading && <KoLoader />}

      <div className={`${styles.content} tableCard`}>
        <div className={styles.header}>
          <KoTitle text='My Expenses' level={4} />
          <KoButton color="primary" variant="solid" label='Add Expense' onClick={() => setIsModalOpen(true)} />
        </div>
        <KoTable
          onSort={onSort}
          onCellClick={onCellClick}
          extraColumnsRight={columnsRight}
          data={{ columns: EXPENSES, rows: expenseList }} />
        <KoPagination
          current={parseInt(pagination.page) || 1}
          total={totalCount}
          showTotal={(total, range) =>
            `${range[0]}-${range[1]} of ${total} records`
          }
          pageSize={pagination.size}
          defaultCurrent={pagination.page}
          onChange={onPagination}
          showQuickJumper={false}
          simple={false}
          responsive={false}
        />
      </div>

      <KoModal title={currentRecord?.expenseId ? 'Update Expense' : 'Add Expense'}
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        afterClose={() => { setCurrentRecord(); }}
        width={'80vw'}
        footer={[
          <KoButton key='cancel' label='Cancel' onClick={() => setIsModalOpen(false)} />,
          <KoButton key='reset' type='primary' label='Submit Expense' onClick={() => {form.submit();setIsModalOpen(false);}} />
        ]}
      >
        <ExpensesCurd form={form} handleFinish={handleFinish} initialValues={currentRecord} />
      </KoModal>

      <KoModal
        title={`Delete Expense?`}
        centered
        open={deleteExpense}
        afterClose={() => { setCurrentRecord(); }}
        handleOk={() => { setCurrentRecord(); setDeleteExpense(false); }}
        onClose={() => { setCurrentRecord(); setDeleteExpense(false); }}
        width={580}
        footer={[
          <KoButton key='cancel' label='Cancel' onClick={() => setDeleteExpense(false)} />,
          <KoButton key='reset' color="danger" variant="solid" type='primary' label='Delete' onClick={() => handleFinishDelete()} />
        ]}
      >
        <div className={styles.suspend}>
          <KoTitle level={5} text={`Are you sure you want to delete this Expense?`} />
          <KoText text={`This action is irreversible, and it will result in the removal of their associated data.`} />
        </div>
      </KoModal>
    </div>
  );
}
